import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import LoginLogo from "../../assets/img/logo-large.png";
import Google from "../../assets/img/google.svg";
import Apple from "../../assets/img/apple.svg";
import userService from '../../Services/UserService';
import { Button } from '@headlessui/react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useAuth from '../../hooks/useAuth';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { Icon } from "../../Components/Landing/Icon";

interface FormSigIn {
  email: string;
  password: string;
}

export default function Login() {
  const [emailAddress, setEmailAddress] = useState('');
  const [showSendEmail, setShowSendEmail] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();
  const auth = useAuth();

  const schema = yup.object().shape({
    email: yup.string().email('Email format is invalid').required('Email is required'),
    password: yup.string().required('Password is required'),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm<FormSigIn>({
    resolver: yupResolver(schema),
    mode: 'onSubmit',
  });

  const watchFields = watch();

  useEffect(() => {
    setErrorMessage('');
  }, [watchFields]);

  async function onSubmit() {
    try {
      const email = watchFields.email;
      const password = watchFields.password;
      setEmailAddress(email);
      console.log(password);

      const user = await auth.signin({ email, password });
      console.log(user);
      if (typeof user === 'string' || user instanceof String) {
        toast.error(user, {
          position: 'top-right',
        });
      } else {
        navigate(process.env.REACT_APP_PublicPath + "/myaccounts", { replace: true });
      }
    } catch (error) {
      if (typeof error === 'string' || error instanceof String) {
        if (error.startsWith('You need to verify your email address before logging in')) {
          setShowSendEmail(true);
        }
        toast.error(error, {
          position: 'top-right',
        });
        //setErrorMessage(error);
      } else {
        toast.error('Connection error has occurred!', {
          position: 'top-right',
        });
        setErrorMessage('Connection error has occurred');
      }
    }
  }

  function resendEmail() {
    userService.ResendConfirmationEmail(emailAddress);
    toast.success('Check your inbox for instructions to verify your email.');
  }

  return (
    <>
      <div className="w-full text-center">
        {showSendEmail && <Button onClick={() => resendEmail()}>Click here to resend the email</Button>}
      </div>
      {!showSendEmail && (
        <div className="flex-1 flex items-center justify-center bg-brand-mist">
          <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
           <h2 className="text-2xl font-extrabold tracking-tight mb-2 text-left">SIGN IN</h2>
           <p className='text-sm mb-6 '> Sign in to access all your data</p>
            <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
              <div>
                <label htmlFor="email" className="block text-sm font-semibold text-gray-700">
                  Email Address
                </label>
                <input
                  type="text"
                  id="email"
                  {...register('email')}
                  className="mt-1 block w-full p-2 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500"
                  placeholder="you@example.com"
                  
                />
                {errors.email && <p className="text-red-500 text-xs">{errors.email.message}</p>}
              </div>
              <div>
                <label htmlFor="password" className="block text-sm font-semibold text-gray-700">
                  Password
                </label>
                <input
                  type="password"
                  id="password"
                  {...register('password')}
                  className="mt-1 block w-full p-2 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Your password"
                  
                />
                {errors.password && <p className="text-red-500 text-xs">{errors.password.message}</p>}
              </div>
              <div className="mb-1 flex items-center justify-between ">
                {/* <div className="block">
                  <input type="checkbox" className="shadow-sm border border-gray-300" id="RememberMe" />
                  <label className="text-sm font-normal text-gray-700" htmlFor="RememberMe">
                    Remember me
                  </label>
                </div> */}

                <Link to="/ForgotPassword">
                  <button type="button" className="text-sm font-normal text-blue-700 hover:underline">Reset password?</button>
                </Link>
              </div>

              <button
                type="submit"
                className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-brand px-6 py-3 text-sm font-semibold text-white shadow-sm hover:bg-brand-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2"
              >
                Login <Icon name="arrow" className="h-4 w-4" />
              </button>

            </form>
            <div className="flex items-center mt-6 justify-center text-sm font-normal">
              Don't have an account?
              <Link to="/registration">
                <button className="justify-center text-sm font-normal text-blue-700 hover:underline pl-1">Register</button>
              </Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
};


